import { Directive, inject, Input } from "@angular/core";
import { AuthService } from "@ponder-core/auth/auth.service";
import { CollectionModifiedEvent } from "@ponder-core/events/collection.events";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { FilteredPreviewItems } from "@ponder-shared/tools/filter/filtered-preview-items";
import { formatCurrency, formatNumber } from "@ponder-shared/utils/numberFormatter";
import { Subscription } from "rxjs";

@Directive()
export abstract class ItemInfoComponent {
    @Input({ required: true }) items: FilteredPreviewItems | undefined;
    protected authService = inject(AuthService);
    protected events = inject(EventBroker);

    private collectionModifiedSub!: Subscription;

    public constructor() {
        this.collectionModifiedSub = this.events.collection.collectionModifiedEvent.subscribe({
            next: (event: CollectionModifiedEvent) => {
                this.items?.onCollectionModified(event);
            }
        });
    }

    public ngOnDestroy(): void {
        this.collectionModifiedSub.unsubscribe();
    }

    public hasAuth(): boolean {
        return this.authService.isAuthed();
    }

    public getCount(): string {
        return formatNumber(this.items?.visibleCount ?? 0);
    }

    public getCollectedCount(): string {
        return formatNumber(this.items?.visibleCollectedCount ?? 0);
    }

    public getDistinctCollectedCount(): string {
        return formatNumber(this.items?.visibleDistinctCollectedCount ?? 0);
    }

    public getValue(): string {
        return formatCurrency(this.items?.visibleValue ?? 0);
    }

    public getSpecialValue(): string {
        return formatCurrency(this.items?.visibleSpecialValue ?? 0);
    }

    public getCollectedValue(): string {
        return formatCurrency((this.items?.visibleCollectedValue  ?? 0) + (this.items?.visibleCollectedSpecialValue ?? 0))
    }

    public hasCollected(): boolean {
        return this.items?.visibleCollectedCount ? true : false;
    }
}